const sections = [
  {
    t: "Housing",
    d: "Lion's Manes do best indoors. Provide a minimum 4-sq-ft enclosure with a solid floor (no wire), hideaway, hay rack, and litter box. Plan at least 3 hours of daily out-of-cage exercise in a rabbit-proofed space.",
  },
  {
    t: "Diet",
    d: "Free-feed timothy or orchard hay (80% of diet). 1/4 cup of quality pellets per 5 lbs body weight daily, plus 1–2 cups of leafy greens (romaine, cilantro, parsley) per 4 lbs. Fresh water always — bowl preferred over bottle.",
  },
  {
    t: "Grooming the mane",
    d: "Brush 2–3 times weekly with a slicker brush during normal coat, daily during seasonal molts. Spot-check the mane and rear for mats — never bathe a rabbit; use a damp cloth if soiled. Trim nails every 4–6 weeks.",
  },
  {
    t: "Health & vet care",
    d: "Lion's Manes can develop wool block — keep hay intake high. Find a rabbit-savvy exotic vet before bringing your bunny home. Spay/neuter at 4–6 months is strongly recommended for behavior, health, and longevity.",
  },
  {
    t: "Temperament",
    d: "Lion's Manes are typically gentle, playful, and people-oriented. They thrive on routine, do well with respectful older children, and can be litter-trained reliably. Bonded pairs are happiest — ask us about pair packages.",
  },
  {
    t: "Lifespan",
    d: "With proper care, 8–10 years is normal, with some living to 12+. A Lion's Mane is a real commitment — please consider the full lifetime before adopting.",
  },
];

export default function CareGuide() {
  return (
    <div className="grain-bg" data-testid="page-care-guide">
      <section className="border-b border-border bg-cream">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:px-12 lg:py-28">
          <div className="section-label">The Care Guide</div>
          <h1 className="mt-4 font-serif text-5xl tracking-tight sm:text-6xl">Raising a happy Lion's Mane.</h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-stone">
            Every rabbit that leaves our rabbitry comes with a printed copy of this guide, a starter bag of our pellet/hay blend, and lifetime support. The basics, below.
          </p>
        </div>
      </section>
      <section className="mx-auto max-w-5xl px-6 py-20 lg:px-12">
        <div className="grid gap-12">
          {sections.map((s, i) => (
            <div key={s.t} className="grid gap-6 border-t border-border pt-12 lg:grid-cols-12" data-testid={`care-section-${i}`}>
              <div className="lg:col-span-4">
                <div className="section-label">0{i + 1}</div>
                <h2 className="mt-3 font-serif text-3xl">{s.t}</h2>
              </div>
              <div className="lg:col-span-8">
                <p className="text-base leading-relaxed text-foreground/85">{s.d}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
